var _circle, _g, _path, _path2, _circle2, _g2, _path3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 11.89,
    r: 11.89,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_391_2886)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.764,
    cy: 11.626,
    r: 7.927,
    fill: "#212529"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.764 13.212a1.585 1.585 0 100-3.17 1.585 1.585 0 000 3.17zm.265-5.549a.264.264 0 10-.529 0v.803a3.171 3.171 0 00-2.896 2.896h-.803a.265.265 0 000 .529h.803a3.172 3.172 0 002.896 2.896v.803a.264.264 0 00.529 0v-.803a3.172 3.172 0 002.895-2.896h.804a.264.264 0 100-.529h-.804a3.171 3.171 0 00-2.895-2.896v-.803zm-.265 6.606a2.642 2.642 0 110-5.284 2.642 2.642 0 010 5.284z",
    fill: "#07AFF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#212529",
    strokeWidth: 0.528,
    strokeDasharray: "2.64 2.64",
    d: "M15.236 24.044h.528v29.593h-.528z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 65.793,
    r: 11.89,
    fill: "#E9ECEF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_391_2886)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.764,
    cy: 65.529,
    r: 7.927,
    fill: "#212529"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 60,
    width: 12,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M10.48 60.243h10.569v10.569H10.48z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.765 65.527c.242 0 .45-.086.622-.258a.848.848 0 00.258-.622.848.848 0 00-.258-.623.849.849 0 00-.622-.258.848.848 0 00-.622.259.848.848 0 00-.259.622c0 .242.086.45.259.622.172.172.38.258.622.258zm0 4.404c-1.182-1.005-2.065-1.94-2.648-2.802-.584-.862-.875-1.66-.875-2.394 0-1.101.354-1.978 1.062-2.632.708-.653 1.529-.98 2.46-.98.933 0 1.753.327 2.461.98.709.654 1.063 1.53 1.063 2.632 0 .734-.292 1.532-.875 2.394-.584.863-1.467 1.797-2.648 2.802z",
    fill: "#07AFF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_391_2886",
    x: 0.439,
    y: 0.528,
    width: 26.423,
    height: 26.423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.114,
    dy: 2.114
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.642
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_2886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_2886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_391_2886",
    x: 0.439,
    y: 54.431,
    width: 26.423,
    height: 26.423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.114,
    dy: 2.114
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.642
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_2886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_2886",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionIcon);
export default __webpack_public_path__ + "static/media/direction-icon.1582dd5730c8d17ae4dbf78449a732c3.svg";
export { ForwardRef as ReactComponent };